export default async function handleLeadTagFilterChanges (eventValue, leadsAwaitingAction, teamInvestigatingLeads, teamClosingLeads, leadNewFilter, leadTypeFilter, leadTierFilter) {
    let awaitingAction = await handleFiltering(eventValue, leadsAwaitingAction, leadNewFilter, leadTypeFilter, leadTierFilter)
    let investigating = await handleFiltering(eventValue, teamInvestigatingLeads, leadNewFilter, leadTypeFilter, leadTierFilter)
    let closing = await handleFiltering(eventValue, teamClosingLeads, leadNewFilter, leadTypeFilter, leadTierFilter)
    return {awaitingAction, investigating, closing}
  }
    
  let handleFiltering = async (eventValue, leads, leadNewFilter, leadTypeFilter, leadTierFilter) => {
    let filteredLeads = []
    let filterTags = true
    console.log(eventValue)
    console.log(leads)
    if (eventValue === 'All' || eventValue.length === 0) {
      filterTags = false
    } 
    for (let i = 0; i < leads.length; i++) {
      let pushLead = true
      let matchingInvestigation = true
      if (filterTags) {
        for (let j = 0; j < eventValue.length; j++) {
          matchingInvestigation = leads[i].tagIds.find(tag => tag === eventValue[j])
          if (!matchingInvestigation) {
            pushLead = false
          }
        }
      }
      if (pushLead && matchingInvestigation) {
        if (leadNewFilter === 'true' && !leads[i].newAssignmentNotification) {
          pushLead = false
        } else if (leadTypeFilter !== 'All') {
          if (leadTypeFilter === 'renegotiation') {
            if (leads[i].targetOutcome !== 'renegotiation') {
              pushLead = false
            }
          } else {
            if (leads[i].targetOutcome !== 'refinance') {
              pushLead = false
            }
          }
        } else if (leadTierFilter !== 'All') {
          if (leadTierFilter === 'Tier 1') {
            if (leads[i].tier !== 1) {
              pushLead = false
            }
          } else if (leadTierFilter === 'Tier 2') {
            if (leads[i].tier !== 2) {
              pushLead = false
            }
          } else {
            if (leads[i].tier !== 0) {
              pushLead = false
            }
          }
        }      
      } else {
        pushLead = false
      }
      if (pushLead) {
        filteredLeads.push(leads[i])
      }
    }

    return filteredLeads
  }